import React from 'react';

/**
 * Parses text and renders @mentions as clickable elements
 * @param text - Text content containing @mentions  
 * @param onProfileClick - Handler when mention is clicked
 */
export const parseCommentWithMentions = (text: string, onProfileClick: (fullName: string) => void) => {
  // Regex to match @FirstName LastName pattern
  const mentionRegex = /@([A-Za-z]+\s+[A-Za-z]+)/g;
  const parts = text.split(mentionRegex);
  
  return parts.map((part, index) => {
    if (index % 2 === 1) {
      // This is a mention
      return (
        <button
          key={index}
          onClick={() => onProfileClick(part)}
          className="text-blue-600 font-medium hover:text-blue-700 hover:underline cursor-pointer bg-blue-50 px-1 rounded"
        >
          @{part}
        </button>
      );
    }
    return <span key={index}>{part}</span>;
  });
};
